<template>
  <div class="info-section-5">
    <div class="tab">
      <product-tab
        name="events"
        sub-title="Events"
        main-info="COMPLETE ONLINE EVENT VIDEO SOLUTION WITHOUT A DEVELOPMENT TEAM "
        sub-info="Fast, risk free and customized to fit your needs."
        text-color="vi-amnium-green"
        :tabIcon="amniumEvents"
        @openProduct="openProduct"
      />
    </div>

    <div class="tab">
      <product-tab
        name="connect"
        sub-title="Connect"
        main-info="COMPLETE MULTI PARTY VIDEO CHAT AND CONFERENCING FOR ALL PLATFORMS"
        sub-info="Fast, risk free and customized to fit your needs."
        text-color="vi-primary"
        :tabIcon="amniumConnect"
        @openProduct="openProduct"
      />
    </div>

    <div class="tab">
      <product-tab
        name="arrs"
        sub-title="ARRS"
        main-info="AFFORDABLE AR REMOTE SUPPORT DEPLOYED WITHIN WEEKS"
        sub-info="No development team needed, risk free and highly customizable"
        text-color="vi-amnium-purple"
        :tabIcon="amniumARRS"
        @openProduct="openProduct"
      />
    </div>

  </div>
</template>

<script>
import ProductTab from "../components/productComponents/ProductTab";

export default {
  name: 'InfoSection5',
  components: {ProductTab},
  data: () => ({
    amniumARRS: require('../assets/icons/amniumARRS.png'),
    amniumConnect: require('../assets/icons/amniumConnect.png'),
    amniumEvents: require('../assets/icons/amniumEvents.png')
  }),
  methods: {
    openProduct(name){
      console.log(name)
      if (name==='events'){
        window.open('https://events.amnium.io/', '_blank')
      }else if (name === 'connect'){
        window.open('https://connect.amnium.io/', '_blank')
      }else if (name === 'arrs'){
        window.open('https://arrs.amnium.io/', '_blank')
      }
    }
  }
}
</script>

<style lang="scss">
@import "InfoSection5.scss";
</style>
